import { render, staticRenderFns } from "./copyImg.vue?vue&type=template&id=1cf9abba&scoped=true&"
import script from "./copyImg.vue?vue&type=script&lang=js&"
export * from "./copyImg.vue?vue&type=script&lang=js&"
import style0 from "./copyImg.vue?vue&type=style&index=0&id=1cf9abba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf9abba",
  null
  
)

export default component.exports